export default __webpack_public_path__ + "static/media/hero_glass_office.6f76e646.jpg";